import NavigationHeader from "../components/Layout/NavigationHeader";

const TermsOfUsePage = () => {
  return (
    <div className={"page_content"}>
      <NavigationHeader />
      <h2>
        Terms of Use
      </h2>
      <span>
        For authorized use only.
      </span>
    </div>);
};

export default TermsOfUsePage;
